var map = {
	"./cn/初中/pc.svg": "8v0C",
	"./en/初中/pc.svg": "NZ5A"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1XkP";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/初中\/pc\.svg$
// module id = 1XkP
// module chunks = 16